import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch, } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/_Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser } from "store/actions";

// import images
import schorLogo1 from "assets/images/schor-logo.png"

//Import config
import ReCAPTCHA from "react-google-recaptcha";
import toastr from "toastr";
import { withTranslation } from "react-i18next";


const sitekey = process.env.REACT_APP_ENV == "development" ? process.env.REACT_APP_CAPTCHA_KEY_DEV : process.env.REACT_APP_CAPTCHA_KEY_PROD


const Login = props => {
  const location = useLocation();
  const navigate = useNavigate()
  const { state } = location

  const [capVal, SetCapVal] = useState(null)

  //meta title
  document.title = "Login | Institute on Governance - Admin & Dashboard";

  const dispatch = useDispatch();
  const { loading } = useSelector((s) => s.Login)

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: ''

    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),

    }),
    onSubmit: (values) => {
      localStorage.setItem("language_id", '1')
      localStorage.setItem("i18nextLng", 'EN')
      localStorage.setItem("I18N_LANGUAGE", 'EN')

      values.email = values.email.trim();
      values.password = values.password.trim();

      if (capVal) {
        values = {
          ...values,
          recaptchaToken: capVal || null
        }
      }
      dispatch(loginUser(values, (res) => {
        if (res.status === "success") {
          localStorage.setItem("number", 20)
          window.location.href = '/dashboard'
          toastr.success(res?.message)

        } else {
          toastr.error(res?.message)
        }
      }))
    }
  });

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }));

  const onChangeCaptcha = (value) => {
    SetCapVal(value)
  }
  const recaptchaRef = useRef(null);


  return (
    <React.Fragment>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">

            <Col md={8} lg={6} xl={5}>
              <div className="main-form-wrapper" style={{ "border": "1px solid #ccc", "padding": "40px 30px 30px", "borderRadius": "20px", 'maxWidth': "800px", "margin": "auto", "background": " #fff" }}>
                <div className="d-flex justify-content-end">
                  <Link to="/" className="text-dark">
                    <i className="bx bx-home h2" />
                  </Link>
                </div>
                <Card className="overflow-hidden">
                  <div>
                    <Link to="/" className="logo-light-element d-block">
                      <div className="avatar-md profile-user-wid mb-4 d-flex justify-content-center">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={schorLogo1}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <Row className="align-items-end text-center justify-content-center">
                    <Col xs={9}>
                      <div className="text-primary p-4 pb-0 heading-form">
                        <h4 className="text-black">Admin Panel</h4>
                        <p className="text-black">Sign in to continue.</p>
                      </div>
                    </Col>
                  </Row>
                  <CardBody className="pt-0 pb-2">
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <div className="mb-3">
                          <Label className="form-label m-0">Email:</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            // onChange={validation.handleChange}
                            // onKeyDown={(e) => {
                            //   if (e.key === " ") {
                            //     e.preventDefault();   // stop space immediately
                            //   }
                            // }}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\s+/g, ""); // remove all spaces
                              validation.setFieldValue("email", val);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email && validation.errors.email ? true : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label m-0">Password:</Label>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type="password"
                            placeholder="Enter Password"
                            // onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\s+/g, ""); // remove all spaces
                              validation.setFieldValue("password", val);
                            }}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          {/* <Label className="form-label m-0">Verification:</Label> */}
                          <div style={{ height: '70px' }}>
                            <ReCAPTCHA
                              ref={recaptchaRef}
                              sitekey={sitekey}
                              onChange={(val) => onChangeCaptcha(val)}
                            />
                          </div>

                        </div>
                        <div className="btn-login-admin mt-3 d-grid batches-add-modal-btn">

                          {
                            loading ?
                              <button
                                type="button"
                                className="btn btn-dark"
                                disabled
                              >
                                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                              </button>
                              :
                              <button
                                // disabled={!capVal}
                                className="btn btn-primary btn-block green-btn"
                                type="submit"
                              >
                                Log In
                              </button>
                          }
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </div>
              <div className="mt-5 text-center">
                <p className="m-0 text-center">
                  © {new Date().getFullYear()} Institute on Governance. {props.t("Crafted with")}{" "}
                  <i className="mdi mdi-heart text-danger" /> {props.t("by Suffescom")}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

Login.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,

};

export default withTranslation()(Login);
